import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Button,
  Pagination,

} from "@mui/material";
import GlobalPoliciesPopup from "../Reusable/Routine/Popup/GlobalPoliciesPopup";

import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sections, sectionPaths } from '../../constants/sectionData';
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";

import pdf from '../../assets/images/fileImage/pdf.png'
import image from '../../assets/images/fileImage/image_icon.png'
import GlobalPoliciesFileViewPopup from '../Reusable/Popup/GlobalPoliciesFileViewPopup'
import GPAdminFileViewPopup from '../Reusable/Popup/GPAdminFileViewPopup'
import { apiService } from "../../api/apiService";
import RoutineTabs from "../Reusable/utils/RoutineTabs";
import { getFileImagePath } from "../Reusable/utils/fileUtils";
import RecruitmentSelectionSectionPopup from "../Reusable/Routine/Popup/RecruitmentSelectionSectionPopup";

interface LocationState {
  management?: string;
  id: any;
  function_l1: any;
  file_name: string;
  created_at: any;
  updated_at:any;
  updated_by:any;
  onClick: (id: any, file_name: string, function_l1: any, created_at: any, updated_at:any, updated_by:any) => void;
  status: any;
  reason_to_approve: any;
  reason_to_revert: any;
}
interface RecruitmentSelectionSectionUploadProps {
  isAdmin?: boolean;
  isManager?: boolean;
}

interface FilterValues {
  function_l1: string;
  function_l2: string;
  function_l3: string;
  function_l4: string;
}

const verticalTabs = [
  { label: "Job Description", value: "a" },
  // { label: "Budget Requests", value: "b" },

];

const RecruitmentSelectionSectionUpload: React.FC<RecruitmentSelectionSectionUploadProps> = ({ isAdmin, isManager }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("1");
  const [verticalTabValue, setVerticalTabValue] = useState("a");
  const [openUpload, setOpenUpload] = useState(false);
  const [open, setOpen] = useState(false);
  const [routineData, setRoutineData] = useState<any[]>([]);

  // const locationState = location.state as LocationState | undefined;
  // const management = locationState?.management || "Default Location Name";
  const management = localStorage.getItem("management") || "Default Location Name";

  const [files, setFiles] = useState<LocationState[]>([]);


  const [isPopupOpen, setPopupOpen] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 3;
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // const paginatedData = routineData.slice(startIndex, endIndex);

  // Tab Status Logic
  const tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[] = [
    { label: 'All', value: 'All', apiStatus: null }, // `null` means no filtering (include all statuses)
    { label: 'Pending', value: 'Pending', apiStatus: 'Pending' },
    { label: 'Approved', value: 'Approved', apiStatus: 'Approved' },
    { label: 'Reverted', value: 'Reverted', apiStatus: 'Reverted' },
  ];
  const selectedStatus = tabStatuses.find(tab => String(tabStatuses.indexOf(tab) + 1) === tabValue)?.value;

  // Filter routineData based on the selected tab status
  const filteredRoutineData = selectedStatus === "All"
    ? routineData
    : routineData.filter(item => item.status === selectedStatus);

  const paginatedData = filteredRoutineData.slice(startIndex, endIndex);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

   const [filterValues, setFilterValues] = useState<FilterValues>({
      function_l1: '',
      function_l2: '',
      function_l3: '',
      function_l4: ''
    });
    

  // Update handleApplyFilter to handle all levels

const handleApplyFilter = (function_l1: string, function_l2: string, function_l3: string, function_l4: string) => {
  const newFilters = {
    function_l1,
    function_l2,
    function_l3,
    function_l4
  };
  setFilterValues(newFilters);
  setPage(1);
  fetchRoutineData(newFilters);
};


  const fetchRoutineData = async (filters: Partial<FilterValues> = {}) => {
    setIsLoading(true);
    try {
      const response = await apiService(
        "/people/filter_recruitment_n_selection",
        "GET",
        {
          management: management,
          section_name: verticalTabs.find((tab) => tab.value === verticalTabValue)?.label,
         ...filters

        },
         undefined,
         instance as PublicClientApplication
      );

      if (response.data) {
        setRoutineData(response.data); // Update routineData
        setFiles(response.data); // Sync files with the API response
      }
    } catch (error) {
      console.error("Error fetching routine data:", error);

      // Set routineData to null on API failure
      setRoutineData([]);

      // Update the error state
      if (error instanceof Error) {
        setError(error.message || "An error occurred");
      } else {
        setError("An error occurred");
      }

      // Check if the error status is 401 and redirect to /login
      if (error instanceof Error && (error as any).response && (error as any).response.status === 401) {
        navigate('/login');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {

    fetchRoutineData();
  }, [verticalTabValue]);


  const [selectedFile, setSelectedFile] = useState<{ id: any; file_name: string, function_l1: any, created_at: any, updated_at:any, updated_by:any, status: any, reason_to_approve: any, reason_to_revert: any } | null>(null);



  const handleViewClick = (id: any, file_name: string, function_l1: any, created_at: any, updated_at:any, updated_by:any, status: any, reason_to_approve: any, reason_to_revert: any) => {
    setPopupOpen(true);
    setSelectedFile({ id, file_name, function_l1, created_at, status, reason_to_approve, reason_to_revert, updated_at, updated_by });
  };






  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    console.log("Tab changed to:", newValue);
    setTabValue(newValue);
  };



  const counts = {
    All: files.length,
    Pending: files.filter((file) => file.status === 'Pending').length,
    Approved: files.filter((file) => file.status === 'Approved').length,
    Reverted: files.filter((file) => file.status === 'Reverted').length,
  };



  return (
    <>
      <RoutineTabs
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        tabStatuses={tabStatuses}
        counts={counts}
        verticalTabValue={verticalTabValue}
        question="Question : Each role in the center has a Job Description that is aligned to the Roles and Responsibilities and reviewed at least once a year."
        verticalTabs={verticalTabs}
        isLoading={isLoading}
        filteredRoutineData={filteredRoutineData}
        paginatedData={paginatedData}
        routineData={routineData}
        itemsPerPage={itemsPerPage}
        handleChangePage={handleChangePage}
        handleViewClick={handleViewClick}
        setOpenUpload={setOpenUpload}
        getFileImagePath={getFileImagePath}
        handleApplyFilter={handleApplyFilter}
        level2={true}
        initialValues={{
          l1: filterValues.function_l1,
          l2: filterValues.function_l2,
          l3: filterValues.function_l3,
          l4: filterValues.function_l4
        }}
        functionL1={filterValues.function_l1}
        functionL2={filterValues.function_l2}
        functionL3={filterValues.function_l3}
        functionL4={filterValues.function_l4}
      />


      {/* Upload form section */}
      <RecruitmentSelectionSectionPopup openUpload={openUpload} setOpenUpload={setOpenUpload} management={management} verticalTabValue={verticalTabs.find(tab => tab.value === verticalTabValue)?.label} onSuccess={fetchRoutineData} />



      {/* File View Popup */}
      {isPopupOpen && selectedFile && (
        <>
          {
            isManager && (
              <GlobalPoliciesFileViewPopup
                onClose={handleClosePopup}
                open={true}
                name={selectedFile.file_name}
                id={selectedFile.id}
                functionl1={selectedFile.function_l1}
                date={selectedFile.updated_at}
                updatedBy={selectedFile.updated_by}
                sectionTitle="MICS Action Plan"
                userDetail={true}
                apiPath={`/people/recruitment_n_selection/${selectedFile.id}`} // Pass the API path for file details

              />
            )
          }


          {isAdmin && (
            <GPAdminFileViewPopup
              onClose={handleClosePopup}
              open={true}
              name={selectedFile.file_name}
              id={selectedFile.id}
              functionl1={selectedFile.function_l1}
              date={selectedFile.updated_at}
              updatedBy={selectedFile.updated_by}
              status={selectedFile.status}
              reason_to_approve={selectedFile.reason_to_approve}
              reason_to_revert={selectedFile.reason_to_revert}
              sectionTitle="MICS Action Plan"
              apiPath={`/people/recruitment_n_selection/${selectedFile.id}`} // Pass the API path for file details
              statusApiPath="/people/recruitment_n_selection_status" // Pass the API path for status updates
            />
          )}
        </>
      )}

    </>
  );
};

export default RecruitmentSelectionSectionUpload;

